import { AxiosResponse } from 'axios/index';
import { message } from "antd";
import { httpRequest } from './HttpRequest'

//导出文件
export function convertRes2Blob(response: AxiosResponse, fileNames?: string) {
    // debugger;
    try {
        const fileName = fileNames ?? response.headers['content-disposition']?.match(/filename=(.*)/)?.[1] ?? "文件.pdf";

        // 将二进制流转为blob
        const blob = new Blob([response.data], { type: 'application/octet-stream' })
        const nav = window.navigator as any
        if (typeof nav.msSaveBlob !== 'undefined') {
            // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
            nav.msSaveBlob(blob, decodeURI(fileName))
        } else {
            // 创建新的URL并指向File对象或者Blob对象的地址
            const blobURL = window.URL.createObjectURL(blob)
            // 创建a标签，用于跳转至下载链接
            const tempLink = document.createElement('a')
            tempLink.style.display = 'none'
            tempLink.href = blobURL
            tempLink.setAttribute('download', decodeURI(fileName))
            // 兼容：某些浏览器不支持HTML5的download属性
            if (typeof tempLink.download === 'undefined') {
                tempLink.setAttribute('target', '_blank')
            }
            // 挂载a标签
            document.body.appendChild(tempLink)
            tempLink.click()
            document.body.removeChild(tempLink)
            // 释放blob URL地址
            window.URL.revokeObjectURL(blobURL)
        }
        message.success("已导出");

    } catch (error) {
        message.warning("导出异常，请重新尝试");
    }
}

//下载文件
export async function fileDownload(url: string, exportFileName?: string) {
    try {
        const data = await httpRequest.getFile(url, { timeout: 300000 })
        convertRes2Blob(data, exportFileName)
        // message.success('已下载')
    } catch (error) {
        message.warning('下载异常，请重新尝试')
    }
}
export const disableExportMsg:string = "维保系统所有导出功能需进行优化，期间将关闭所有导出功能，如有导出需求，请联系信息中心"
